"use strict";

exports.__esModule = true;

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GatsbyRemarkCodeReplsRedirect = function (_Component) {
  (0, _inherits3.default)(GatsbyRemarkCodeReplsRedirect, _Component);

  function GatsbyRemarkCodeReplsRedirect() {
    (0, _classCallCheck3.default)(this, GatsbyRemarkCodeReplsRedirect);
    return (0, _possibleConstructorReturn3.default)(this, _Component.apply(this, arguments));
  }

  GatsbyRemarkCodeReplsRedirect.prototype.componentDidMount = function componentDidMount() {
    this.form.submit();
  };

  GatsbyRemarkCodeReplsRedirect.prototype.render = function render() {
    var _this2 = this;

    var _props$pathContext = this.props.pathContext,
        action = _props$pathContext.action,
        payload = _props$pathContext.payload;


    return _react2.default.createElement(
      "form",
      {
        style: { paddingBottom: "50px" },
        ref: function ref(form) {
          _this2.form = form;
        },
        action: action,
        method: "POST"
      },
      _react2.default.createElement("input", { type: "hidden", name: "data", value: payload }),
      _react2.default.createElement(
        "p",
        null,
        "Not automatically redirecting?"
      ),
      _react2.default.createElement(
        "p",
        null,
        _react2.default.createElement("input", { type: "submit", value: "Click here" })
      )
    );
  };

  return GatsbyRemarkCodeReplsRedirect;
}(_react.Component);

GatsbyRemarkCodeReplsRedirect.propTypes = {
  pathContext: _propTypes2.default.shape({
    action: _propTypes2.default.string.isRequired,
    payload: _propTypes2.default.object.isRequired
  }).isRequired
};

exports.default = GatsbyRemarkCodeReplsRedirect;


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-remark-code-repls/default-redirect-template.js
// module id = 745
// module chunks = 118566575483826